import { Box, Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { AccountOnboardingStep, AccountService } from "../../../api/psc";

const HintTypography = styled(Typography)({
    fontSize: "1.1rem",
});

export const getDesktopSignupTutorial = (businessLine?: string) => {
    return [
        {
            step: "desktop-signup-1",
            hint: (
                <>
                    <HintTypography>
                        در یک تعریف کلی، دو روش مارکتینگی رایج برای پیدا کردن
                        پروژه‌ها این‌ها هستند:
                    </HintTypography>
                    <ul>
                        <li>
                            <HintTypography>
                                بازاریابی درونگرا (Inbound): صرف هزینه‌های زیاد
                                برای مارکتینگ، تبلیغات، سئو، شبکه‌های اجتماعی و
                                … به امید دیده شدن و این که مشتری شما را پیدا
                                کرده و به سراغ‌تان بیاید.
                            </HintTypography>
                        </li>
                        <li>
                            <HintTypography>
                                بازاریابی برونگرا - مستقیم (Outbound): مراجعه‌ی
                                مستقیم به سازنده‌ها توسط بازاریاب‌های فروش و
                                جستجوی میدانی گسترده، که مستلزم هزینه و زمان و
                                منابعی است که اغلب بی‌نتیجه و ناکارآمد است.
                            </HintTypography>
                        </li>
                    </ul>
                    <HintTypography>
                        اما روش سوم استفاده از ابزار و روش‌های هوشمندی است که با
                        کمترین هزینه و زمان شما را به سازنده‌ها می‌رسانند،
                        زمانبندی هوشمند کلید ورود به فرآیند فروش به سازنده‌ها و
                        پروژه‌هاست. برای درک این اصل استراتژیک، باید با منطق آن
                        آشنا شویم.
                    </HintTypography>
                </>
            ),
            title: "به پنل کاربری پرشین سازه خوش آمدید",
            action: () => {},
            couldNotStepBack: true,
        },
        {
            step: "desktop-signup-2",
            hint: (
                <>
                    <HintTypography>
                        در صنعت ساختمان دو نوع از فروش وجود دارد که تعیین
                        کننده‌ی مسیر و روش شما است:
                    </HintTypography>
                    <ol>
                        <li>
                            <HintTypography>
                                فروش از نوع سفارش‌گذاری (سریع و عادی):
                            </HintTypography>
                            <HintTypography>
                                در این شکل فروش مراحل مذاکره، خرید و اجرا بسیار
                                به هم نزدیک یا یکی هستند و از این‌رو شرط موفقیت
                                شما در فروش تماس و ارتباط با سازنده در مرحله‌ی
                                نزدیک به اجرا یا خود اجراست، دقیقا در لحظه‌ی
                                نیاز سازنده. مانند محصولات روتین: سیمان، آجر، گچ
                                و … .
                            </HintTypography>
                        </li>
                        <li>
                            <HintTypography>
                                فروش از نوع سفارشی‌سازی (زمانبر و مشاوره‌ای):
                            </HintTypography>
                            <HintTypography>
                                در این نوع، سازنده برای مذاکره و تصمیم به خرید
                                زمان بیشتری صرف می‌کند و میان مرحله‌ی مذاکره،
                                مرحله‌ی خرید و مرحله‌ی اجرا فاصله‌ی زمانی است.
                                در این حالت شرط موفقیت شما تماس و ارتباط با
                                سازنده از چند مرحله پیش از اجرا و مذاکره و
                                اعتمادسازی است. مانند محصولاتی که تولید و تامین
                                آنها سفارشی یا زمانبر است: آسانسور، در، پنجره،
                                کابینت و … .
                            </HintTypography>
                        </li>
                    </ol>
                    <HintTypography>
                        پس برای موفقیت باید بدانید چه زمانی و در کدام مرحله سراغ
                        سازنده بروید.
                    </HintTypography>
                </>
            ),
            title: "انواع فروش در صنعت ساختمان",
            action: () => {},
        },
        {
            step: "desktop-signup-3",
            hint: (
                <>
                    <ul>
                        <li>
                            <HintTypography>
                                مرحله‌ی مذاکره: زمانی که سازنده سراغ گزینه‌ها،
                                بررسی بازار محصول مورد نظر و استعلام قیمت
                                می‌رود. این مرحله بهترین زمان برای برقراری
                                ارتباط با سازنده، مذاکره و معرفی محصول و خدمات
                                است.
                            </HintTypography>
                        </li>
                        <li>
                            <HintTypography>
                                مرحله‌ی تصمیم‌گیری و خرید: در این مرحله سازنده
                                باید تصمیم گرفته و خرید را انجام دهد. در این
                                پنجره‌ی زمانی، شما باید با پیگیری‌های درست و
                                ارائه‌ی پیشنهادها و شرایط مناسب، به سازنده کمک
                                کنید تا به تصمیم نهایی خرید برسد.
                            </HintTypography>
                        </li>
                        <li>
                            <HintTypography>
                                مرحله‌ی اجرا: حالا سازنده از شما خرید و شما باید
                                محصول را آماده کرده و برای اجرا/نصب اقدام کنید.
                                اما فراموش نکنید فروش تمام نشده، باید رضایتش را
                                جلب کنید تا در آینده باز سراغ شما بیاید.
                            </HintTypography>
                        </li>
                    </ul>
                </>
            ),
            title: "فرآیند خرید سازنده",
            action: () => {},
        },
        {
            step: "desktop-signup-4",
            hint: (
                <>
                    <HintTypography>
                        حالا که منطق فرآیند فروش را متوجه شدید، بیایید استفاده‌ی
                        عملی از پلتفرم پرشین سازه برای عملی کردن فرآیند فروش‌تان
                        را با هم پیش ببریم.
                    </HintTypography>
                    <HintTypography>
                        در این بخش می‌توانید فیلتربندی‌های مورد نظرتان را (مانند
                        مرحله، منطقه، متراژ، تعداد طبقه و …) براساس کارتان
                        انتخاب کنید تا پروژه‌های مرتبط با شما نمایش داده شوند.
                    </HintTypography>
                </>
            ),
            title: "مسیر فروش به سازنده‌ها در پلتفرم پرشین سازه",
            action: () => {},
        },
        {
            step: "desktop-signup-5",
            hint: (
                <>
                    <HintTypography>
                        اینجا مراحل مناسب برای ارتباط‌گیری و آغاز مذاکره را
                        براساس زمینه‌ی کاری‌تان که قبل‌تر مشخص کردید، انتخاب
                        کنید و روی اعمال فیلتر بزنید.
                    </HintTypography>
                    {businessLine && (
                        <HintTypography>
                            (براساس زمینه‌ی کاری شما، پیشنهاد ما این مراحل
                            هستند: «{businessLine}»)
                        </HintTypography>
                    )}
                </>
            ),
            title: "مسیر فروش: مراحل",
            action: () => {},
            couldNotSkip: true,
        },
        {
            step: "desktop-signup-6",
            hint: (
                <>
                    <HintTypography>
                        در این صفحه فهرست کارتی پروژه‌هایی که براساس انتخاب شما
                        و در مرحله‌ی مناسب شما هستند نمایش داده می‌شوند. روی این
                        کارت کلیک کنید.
                    </HintTypography>
                </>
            ),
            title: "مسیر فروش: پروژه‌ها",
            action: () => {},
            couldNotSkip: true,
        },
        {
            step: "desktop-signup-7",
            hint: (
                <>
                    <HintTypography>
                        در هر کارت پروژه، شما مشخصات کامل پروژه را می‌بینید.
                        حتما همیشه عکس‌های به‌روز پروژه و تاریخ به‌روزرسانی آنها
                        را بررسی کنید تا از وضعیت فعلی پروژه و مرحله‌ی آن مطمئن
                        شوید. با این کار می‌توانید روند کاری پروژه - فعال بودن
                        یا نبودن و سرعت پیشرفت - آن را تشخیص دهید.
                    </HintTypography>
                    <HintTypography>
                        فقط درصورتی با سازنده تماس بگیرید که تصاویر به‌روز
                        پروژه، تاییدی بر مرحله‌ی ذکر شده برای آن باشند. فراموش
                        نکنید هدف اصلی در تماس اول فروش نیست، بلکه برقراری
                        ارتباط و آغاز مسیر اعتمادسازی و ادامه یافتن مذاکرات
                        (مثلا بازدید از شوروم یا جلسه‌ی حضوری) جهت فروش است.
                    </HintTypography>
                    <HintTypography>
                        مشخصات پروژه مانند آدرس، متراژ، نوع سازه، طبقه و … به
                        همراه نام و شماره تماس سازنده در اینجا به شما نمایش داده
                        می‌شوند.
                    </HintTypography>
                </>
            ),
            title: "مسیر فروش: کارت پروژه",
            action: () => {},
            couldNotStepBack: true,
        },
        {
            step: "desktop-signup-8",
            fullContent: true,
            hint: (
                <>
                    <Stack
                        alignItems="center"
                        spacing={2}
                        sx={{ height: "100%" }}
                    >
                        <Box sx={{ flex: 1, overflow: "hidden" }}>
                            <video height="100%" autoPlay loop muted>
                                <source
                                    src="/videos/map_tutorial.webm"
                                    type="video/webm"
                                />
                                مرورگر شما از پخش ویدیو پشتیبانی نمی‌کند.
                            </video>
                        </Box>
                        <HintTypography>
                            در هر کارت پروژه، شما مشخصات کامل پروژه را می‌بینید.
                            حتما همیشه عکس‌های به‌روز پروژه و تاریخ به‌روزرسانی
                            آنها را بررسی کنید تا از وضعیت فعلی پروژه و مرحله‌ی
                            آن مطمئن شوید. با این کار می‌توانید روند کاری پروژه
                            - فعال بودن یا نبودن و سرعت
                        </HintTypography>
                    </Stack>
                </>
            ),
            title: "مسیر فروش: پروژه‌ها روی نقشه",
            action: () => {},
            couldNotStepBack: true,
        },
        {
            step: "desktop-signup-9",
            hint: (
                <>
                    <HintTypography>
                        شما می‌توانید تمامی پروژه‌ها را براساس فیلتربندی که مشخص
                        کردید، روی نقشه ببینید و با کلیک روی آنها و درآوردن
                        اطلاعات لازم مانند آدرس، برای مراجعه‌ی حضوری منطقه‌ای هم
                        برنامه‌ریزی کنید.
                    </HintTypography>
                </>
            ),
            title: "مسیر فروش: پروژه‌ها روی نقشه - ۲",
            action: () => {},
            couldNotStepBack: true,
        },
        {
            step: "desktop-signup-10",
            hint: (
                <>
                    <HintTypography>
                        پلتفرم پرشین سازه ابزارها و امکانات دیگری مانند پنل
                        پیامکی هم در اختیار شما قرار می‌دهد. اما فراموش نکنید
                        همه‌ی ابزارها را هم که داشته باشید، اگر به درستی استفاده
                        نکنید، پیشرفت زیادی نخواهید کرد.
                    </HintTypography>
                    <HintTypography>
                        انتخاب امروز شما، جایگاه شما در آینده را می‌سازد.
                        فرصت‌ها در گذرند و رقبا در تلاش. تصمیم شما چیست؟ روش
                        هوشمندی مانند بانک اطلاعات تا بیشتر رشد کنید؟
                    </HintTypography>
                    <HintTypography>
                        این یک هزینه نیست، یک سرمایه‌گذاری است.
                    </HintTypography>
                </>
            ),
            title: "برگ برنده دست شماست، درست بازی کنید تا پیروز شوید",
            action: () => {
                AccountService.updateOnboarding("1", {
                    step: AccountOnboardingStep.TUTORIAL,
                });
            },
        },
    ];
};
